// Generated by script, please do not edit this file.
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
import * as React from 'react';
import { forwardRef } from 'react';
var SingleSource = function(props, ref) {
    return /*#__PURE__*/ React.createElement("svg", _object_spread({
        xmlns: "http://www.w3.org/2000/svg",
        width: "1em",
        height: "1em",
        viewBox: "0 0 16 16",
        fill: "currentColor",
        ref: ref
    }, props), /*#__PURE__*/ React.createElement("path", {
        d: "M6.5 13a1.5 1.5 0 1 1-.001 3.001A1.5 1.5 0 0 1 6.5 13m0 1a.5.5 0 1 0 0 1 .5.5 0 0 0 0-1m4.5-1a1 1 0 0 1 1 1v1a1 1 0 0 1-1 1h-1a1 1 0 0 1-1-1v-1a1 1 0 0 1 1-1zm0 1h-1v1h1zm3.5-1a1.5 1.5 0 1 1-.001 3.001A1.5 1.5 0 0 1 14.5 13m0 1a.5.5 0 1 0 0 1 .5.5 0 0 0 0-1M3 10h11a1 1 0 0 1 1 1H4a1 1 0 0 1-1-1m1-2h8a1 1 0 0 1-1 1H3"
    }), /*#__PURE__*/ React.createElement("path", {
        d: "M14 10a1 1 0 0 1 1 1v2.5a.5.5 0 0 1-1 0zM10 10h1v4h-1zM6 10h1v4H6zM4 8v3a1 1 0 0 1-1-1V9a1 1 0 0 1 1-1"
    }), /*#__PURE__*/ React.createElement("path", {
        d: "M5.433 0c.283 0 .559.094.833.309.341.339.629.657.945 1.031l.545.66H10.5c.678 0 1.409.686 1.492 1.372L12 3.5V8a1 1 0 0 1-1 1V3.5c0-.153-.261-.429-.438-.489L10.5 3H7.567c-.318 0-1.656-1.634-1.958-1.94a.3.3 0 0 0-.114-.053L5.433 1H1.3c-.14 0-.26.103-.292.244L1 1.318V7.5c0 .172.33.5.5.5a.5.5 0 0 1 0 1C.822 9 .091 8.314.008 7.628L0 7.5V1.318C0 .638.509.074 1.167.007L1.3 0z"
    }));
};
var ForwardRef = /*#__PURE__*/ forwardRef(SingleSource);
export default ForwardRef;
